export default "__VITE_ASSET__D9xMd95r__"